import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {
  ProcedureRunDataEntryMode,
  ProcedureType,
  StudyType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {
  AssayDevelopmentStudyState,
  StudySchema,
  TypedStudyAdapter,
} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunAndPlanOverviewTabContents from '../shared/MultiProcedureRunAndPlanOverviewTabContents';
import ProcedureRunAndPlanOverview from '../shared/ProcedureRunAndPlanOverview';

export const ProcessDevelopmentStudyAdapter: TypedStudyAdapter<never, AssayDevelopmentStudyState> = {
  type: StudyType.PROCESS_DEVELOPMENT,

  procedureType: ProcedureType.RECIPE,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: true,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: true,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  isOOTBChartingEnabled: true,

  maxRunsPerStudy: () => BenchlingConfig.STUDIES_MAX_NUM_RUNS_PER_PD_STUDY,

  defaultProcedureRunDataEntryMode: ProcedureRunDataEntryMode.ALL_CONDITION_REPLICATES_TOGETHER,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  renderMetadataSection(_state: AssayDevelopmentStudyState) {
    return <></>;
  },

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },
  creation: {},
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: MultiProcedureRunAndPlanOverviewTabContents,
      design: null,
      execution: ProcedureRunAndPlanOverview,
    },
  },
  review: {},
};
